export default {
      id: "currency-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#currency-usage",
      toString: function () {
        return this.url;
      }
    }